// Add your custom JS here.
(function($) {
    $(document).ready(function($){
        
        function updateCountdown() {
            const $container = $('#countdown-minimal');
            if (!$container.length) return;

            const targetDate = new Date($container.data('target').replace(/-/g, "/"));
            const now = new Date();
            
            if (targetDate <= now) {
                $container.find('.number').text('00');
                return;
            }

            // 1. Calcular meses totales
            let months = (targetDate.getFullYear() - now.getFullYear()) * 12 + (targetDate.getMonth() - now.getMonth());
            
            // Ajuste de fecha temporal para calcular el resto de días
            let tempDate = new Date(now.getTime());
            tempDate.setMonth(tempDate.getMonth() + months);

            if (tempDate > targetDate) {
                months--;
                tempDate = new Date(now.getTime());
                tempDate.setMonth(tempDate.getMonth() + months);
            }

            // 2. Calcular días y horas restantes
            const diffMs = targetDate - tempDate;
            const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diffMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));

            // 3. Pintar en el HTML
            $('#m-months').text(months.toString().padStart(2, '0'));
            $('#m-days').text(days.toString().padStart(2, '0'));
            $('#m-hours').text(hours.toString().padStart(2, '0'));
        }

        // Actualizar cada segundo
        setInterval(updateCountdown, 1000);
        updateCountdown();

    });
})(jQuery);